import React from "react";

function ReverseRightIcon({ fill, ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={fill ?? ""}
      viewBox=" 0 0 16 16"
      {...restProps}
    >
      <path
        d="M10.474 1.289a.747.747 0 0 0-.457 1.066c.023.047.373.417.777.823l.734.739-2.677.011c-2.861.013-2.81.011-3.352.15A4.745 4.745 0 0 0 1.972 8.04a6.101 6.101 0 0 0 0 1.253 4.737 4.737 0 0 0 3.568 3.971c.558.138.482.136 4.353.136h3.614l.122-.057a.74.74 0 0 0 0-1.353c-.122-.057-.123-.057-3.789-.071-3.386-.014-3.682-.019-3.863-.062-.967-.232-1.761-.842-2.198-1.688a3.246 3.246 0 0 1 .527-3.74 3.267 3.267 0 0 1 1.337-.854c.482-.161.491-.161 3.316-.162h2.572l-.738.741c-.824.828-.856.872-.856 1.179 0 .418.312.73.73.73.327 0 .29.031 1.859-1.537 1.568-1.569 1.537-1.532 1.537-1.859 0-.328.031-.291-1.537-1.859-1.097-1.097-1.447-1.431-1.539-1.472a.813.813 0 0 0-.513-.047"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default ReverseRightIcon;
